import PropTypes from 'prop-types'
import React from 'react'
import Editor from 'components/Editor'
import ListRow from 'components/ListRow'
import { USER_MODEL_KEY, USER_MODEL_PLACEHOLDER } from 'models/daos/user/constants'

class UserRowBio extends React.Component {
  static defaultProps = {
    isEditing: null,
    value: '',
    hasNoPadding: null,
    onChange: null
  }

  static propTypes = {
    value: PropTypes.string,
    isEditing: PropTypes.bool,
    hasNoPadding: PropTypes.bool,
    onChange: PropTypes.func
  }

  handleChange (value) {
    this.props.onChange(value)
  }

  renderBio () {
    return (
      <ListRow.Text>
        {this.props.value}
      </ListRow.Text>
    )
  }

  renderBody () {
    if (!this.props.isEditing) {
      return this.renderBio()
    }
    return this.renderEditBio()
  }

  renderEditBio () {
    const props = {
      value: this.props.value,
      placeholder: USER_MODEL_PLACEHOLDER[USER_MODEL_KEY.BIO],
      onChange: this.handleChange.bind(this)
    }
    return <Editor {...props} />
  }

  render () {
    return (
      <div>
        {this.renderBody()}
      </div>
    )
  }
}

export default UserRowBio
